import validate from "/www/wwwroot/echopus.com/node_modules/nuxt/dist/pages/runtime/validate.js";
import transition_45global from "/www/wwwroot/echopus.com/middleware/transition.global.ts";
import manifest_45route_45rule from "/www/wwwroot/echopus.com/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  transition_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}